import script from "./SwitchVerticalIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchVerticalIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__